module.exports = __webpack_public_path__ + "static/img/store-icon8.e5a1f16.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon8.png
// module id = Omya
// module chunks = 1